import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterModule } from '@angular/router';
import { BusinessLoginFooterComponent } from '@components/business-login-footer/business-login-footer.component';
import { CreatePasswordFormComponent } from '@components/create-password-form/create-password-form.component';
import { LoadingComponent } from '@components/loading/loading';
import { LoginRedirectLoadingComponent } from '@components/login-redirect-loading/login-redirect-loading';
import { MapfreButtonComponent } from '@components/mapfre-button/mapfre-button.component';
import { MapfreFooterSinisterComponent } from '@components/mapfre-footer-sinister/mapfre-footer.component';
import { MapfreHomeTabsComponent } from '@components/mapfre-home-tabs/mapfre-home-tabs.component';
import { MapfreIbanInputComponent } from '@components/mapfre-iban-input/mapfre-iban-input.component';
import { MapfreInputComponent } from '@components/mapfre-input/mapfre-input.component';
import { MapfreLoginFooterComponent } from '@components/mapfre-login-footer/mapfre-login-footer.component';
import { MapfreLoginHeaderComponent } from '@components/mapfre-login-header/mapfre-login-header.component';
import { MapfreSliderButtonsComponent } from '@components/mapfre-slider-buttons/mapfre-slider-buttons.component';
import { MapfreTabsComponent } from '@components/mapfre-tabs/mapfre-tabs.component';
import { MapfreWhiteBoxLayout } from '@components/mapfre-whitebox-layout/mapfre-whitebox-layout.component';
import { Notification3Component } from '@components/notification-3/notification-3.component';
import { RedsysFormComponent } from '@components/redsys-form/redsys-form.component';
import { RedsysLoadingProcessingComponent } from '@components/redsys-loading-processing/redsys-loading-processing';
import { RedsysLoadingComponent } from '@components/redsys-loading/redsys-loading';
import { SelectGlobalLanguageComponent } from '@components/select-global-language/select-global-language.component';
import { SigningKeyComponent } from '@components/signing-key/signing-key.component';
import { ZendeskChatComponent } from '@components/zendesk-chat/zendesk-chat.component';
import { AnimationHomeDirective } from '@directives/animation-home';
import { AutoFocusedDirective } from '@directives/auto-focused-form';
import { RetrieveSMSDirective } from '@directives/retrieve-sms.directive';
import { IonicModule } from '@ionic/angular';
import { ValidateEmailComponent } from '@modules/businesses/components/validate-email/validate-email.component';
import { OpinatorComponent } from '@modules/client-area/components/opinator/opinator.component';
import { DeregisterRequestComponent } from '@modules/deregister/components/deregister-request/deregister-request.component';
import { HealthEmbeddedAccessComponent } from '@modules/health-app/components/health-embedded-access/health-embedded-access.component';
import { TrimDirective } from '@modules/login/directives/trim.directive';
import { RgpduePolicyEntitiesDetailComponent } from '@modules/public-operations/components/rgpdue-policy-entities-detail/rgpdue-policy-entities-detail.component';
import { RgpduePolicyInfoDetailComponent } from '@modules/public-operations/components/rgpdue-policy-info-detail/rgpdue-policy-info-detail.component';
import { RgpdueRightsProtectionDetailComponent } from '@modules/public-operations/components/rgpdue-rights-protection-detail/rgpdue-rights-protection-detail.component';
import { ErrorSendSMSModalComponent } from '@modules/register/components/error-send-sms-modal/error-send-sms-modal-component';
import { TranslateModule } from '@ngx-translate/core';
import { IonBottomDrawerModule } from 'ion-bottom-drawer';
import { MaterialModule } from '../material.module';
import { RequestResultComponent } from '../modules/client-area/components/request-result/request-result.component';
import { PaymentPlanComponent } from '../modules/payment-plan/components/payment-plan/payment-plan';
import { CustomToggleComponent } from './components/custom-toggle/custom-toggle.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DocumentComponent } from './components/document/document.component';
import { FaqComponent } from './components/faq/faq/faq.component';
import { GenesysChatComponent } from './components/genesys-chat/genesys-chat.component';
import { MailItemComponent } from './components/mail-item/mail-item.component';
import { MapComponent } from './components/map/map/map.component';
import { MapfreAppHeaderComponent } from './components/mapfre-app-header/mapfre-app-header.component';
import { MapfreFooterComponent } from './components/mapfre-footer/mapfre-footer.component';
import { MapfreUpdateDNIComponent } from './components/mapfre-update-dni/mapfre-update-dni.component';
import { MapfreWebHeaderComponent } from './components/mapfre-web-header/mapfre-web-header.component';
import { ProfileMenuComponent } from './components/mapfre-web-header/profile-menu/profile-menu.component';
import { MenuComponent } from './components/menu/menu.component';
import { Notification2Component } from './components/notification-2/notification-2.component';
import { NotificationComponent } from './components/notification/notification.component';
import { PhoneContactComponent } from './components/phone-contact/phone-contact.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { PwaPatrimonialsFooterComponent } from './components/pwa-patrimonials-footer/pwa-patrimonials-footer.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SelectFileComponent } from './components/select-file/select-file.component';
import { SelectLanguageComponent } from './components/select-language/select-language.component';
import { ServiceItemComponent } from './components/service-item/service-item.component';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { StaticMapComponent } from './components/static-map/static-map.component';
import { SuperbonusHeaderComponent } from './components/superbonus-header/superbonus-header.component';
import { TecuidamosHomeComponent } from './components/tecuidamos-home/tecuidamos-home.component';
import { TecuidamosPresentationComponent } from './components/tecuidamos-presentation/tecuidamos-presentation.component';
import { TopNavigationComponent } from './components/top-navigation/top-navigation.component';
import { WebMitekCaptureModalComponent } from './components/web-mitek-capture-modal/web-mitek-capture-modal.component';
import { WebMitekCaptureComponent } from './components/web-mitek-capture/web-mitek-capture.component';
import { ActionFormDirective } from './directives/action-form';
import { AnimationCollapseVerticalDirective } from './directives/animation-collapse-vertical';
import { AnimationHeaderDirective } from './directives/animation-header';
import { AnimationProductResumeDirective } from './directives/animation-product-resume';
import { AnimationSegmentToolbarDirective } from './directives/animation-segment-toolbar';
import { DeleteIonBackdropDirective } from './directives/delete-ion-backdrop';
import { HackIosKeyboardOffsetDirective } from './directives/hack-ios-keyboard-offset';
import { HorizontalScrollDirective } from './directives/horizontal-scroll';
import { KeyboardAttachDirective } from './directives/keyboard-attach.directive';
import { MaxLengthDirective } from './directives/max-length';
import { NumericValueDirective } from './directives/numeric-value';
import { PhoneCallableDirective } from './directives/phone-callable';
import { TwoDecimalsDirective } from './directives/two-decimals';
import { BytesPipe } from './pipes/bytes.pipe';
import { CapitalizeStringPipe } from './pipes/capitalize.pipe';
import { DistancePipe } from './pipes/distance.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { FormErrorPipe } from './pipes/form-error.pipe';
import { FormatMomentDatePipe } from './pipes/format-moment-date.pipe';
import { HideIbanPipe } from './pipes/hide-iban.pipe';
import { NameCompositionPipe } from './pipes/name-composition.pipe';
import { NumberFloorPipe } from './pipes/number-floor.pipe';
import { ProfilePasswordPipe } from './pipes/profile-password.pipe';
const DECLARATIONS = [
  // Components
  MenuComponent,
  CustomToggleComponent,
  CreatePasswordFormComponent,
  MapfreFooterComponent,
  MapfreFooterSinisterComponent,
  MapfreWebHeaderComponent,
  MapfreAppHeaderComponent,
  MapfreUpdateDNIComponent,
  WebMitekCaptureComponent,
  WebMitekCaptureModalComponent,
  ProfileMenuComponent,
  SearchBarComponent,
  TopNavigationComponent,
  Notification3Component,
  Notification2Component,
  NotificationComponent,
  Notification3Component,
  MailItemComponent,
  ServiceItemComponent,
  PhoneContactComponent,
  SuperbonusHeaderComponent,
  MapComponent,
  DocumentComponent,
  SelectFileComponent,
  FaqComponent,
  StaticMapComponent,
  SelectLanguageComponent,
  SelectGlobalLanguageComponent,
  TecuidamosHomeComponent,
  TecuidamosPresentationComponent,
  StarRatingComponent,
  PaymentPlanComponent,
  RequestResultComponent,
  SigningKeyComponent,
  ProgressBarComponent,
  PwaPatrimonialsFooterComponent,
  DatePickerComponent,
  RgpduePolicyInfoDetailComponent,
  RgpduePolicyEntitiesDetailComponent,
  RgpdueRightsProtectionDetailComponent,
  MapfreWhiteBoxLayout,
  MapfreIbanInputComponent,
  ValidateEmailComponent,
  OpinatorComponent,
  RedsysFormComponent,
  LoadingComponent,
  RedsysLoadingComponent,
  RedsysLoadingProcessingComponent,
  BusinessLoginFooterComponent,
  LoginRedirectLoadingComponent,
  HealthEmbeddedAccessComponent,
  GenesysChatComponent,
  ZendeskChatComponent,
  DeregisterRequestComponent,
  MapfreHomeTabsComponent,
  MapfreTabsComponent,
  MapfreInputComponent,
  MapfreButtonComponent,
  MapfreSliderButtonsComponent,
  MapfreLoginHeaderComponent,
  MapfreLoginFooterComponent,
  ErrorSendSMSModalComponent,
  // Directives
  TrimDirective,
  ActionFormDirective,
  HorizontalScrollDirective,
  AnimationHeaderDirective,
  AnimationCollapseVerticalDirective,
  DeleteIonBackdropDirective,
  PhoneCallableDirective,
  RetrieveSMSDirective,
  AnimationSegmentToolbarDirective,
  AnimationProductResumeDirective,
  AnimationHomeDirective,
  TwoDecimalsDirective,
  MaxLengthDirective,
  HackIosKeyboardOffsetDirective,
  NumericValueDirective,
  KeyboardAttachDirective,
  // Pipes
  DistancePipe,
  BytesPipe,
  EllipsisPipe,
  CapitalizeStringPipe,
  FormErrorPipe,
  ProfilePasswordPipe,
  FormatMomentDatePipe,
  NumberFloorPipe,
  HideIbanPipe,
  NameCompositionPipe,
  AutoFocusedDirective
];

@NgModule({
  declarations: [
    ...DECLARATIONS
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    MaterialModule,
    IonBottomDrawerModule,
    TranslateModule,
    GoogleMapsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    MaterialModule,
    IonBottomDrawerModule,
    TranslateModule,
    ...DECLARATIONS
  ],
  providers: [DatePipe]
})
export class SharedModule {}
